import { useQuery } from '@tanstack/react-query'
import {
  ExecutiveMetricsResponse,
  ContractDateToUse,
  GetMetricsRequestTimePeriod,
  useGetNetworkPartnershipMetrics,
  useGetNetworkStateMetrics,
} from '@urbanx/agx.rex.client'
import dayjs from 'dayjs'

export enum NetworkReportType {
  State = 'state',
  PartnershipLevel = 'partnershipLevel',
}

const useExecutiveGetNetworkMetrics = (
  networkReportType: NetworkReportType,
  contractDateToUse: ContractDateToUse,
  fromDate: string,
  toDate: string,
  timePeriod: GetMetricsRequestTimePeriod
) => {
  const { getNetworkStateMetrics } = useGetNetworkStateMetrics({
    onSuccess: () => {},
    onError: () => {},
  })

  const { getNetworkPartnershipMetrics } = useGetNetworkPartnershipMetrics({
    onSuccess: () => {},
    onError: () => {},
  })

  const { data, isPending, isError } = useQuery<
    ExecutiveMetricsResponse | undefined
  >({
    queryKey: [
      networkReportType,
      contractDateToUse,
      fromDate,
      toDate,
      timePeriod,
    ],
    queryFn: async () => {
      if (networkReportType === NetworkReportType.State) {
        return await getNetworkStateMetrics({
        contractDateToUse,
        fromDate: dayjs(fromDate).toDate(),
        toDate: dayjs(toDate).toDate(),
        timePeriod,
      })
      }
      if (networkReportType === NetworkReportType.PartnershipLevel) {
        return await getNetworkPartnershipMetrics({
        contractDateToUse,
        fromDate: dayjs(fromDate).toDate(),
        toDate: dayjs(toDate).toDate(),
        timePeriod,
      })
      }
    },
  })

  return {
    data,
    isPending,
    isError,
  }
}

export default useExecutiveGetNetworkMetrics
